import Landing from '@/views/Landing.vue';
import Signup from '@/views/Signup.vue';
import Registration from '@/views/Registration.vue';
import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import Account from '@/views/Account.vue';
import Invite from '@/views/Invite.vue';
import Legal from '@/views/Legal.vue';
import MailRequest from '@/views/MailRequest.vue';
import store from '@/store';
import Datenschutz from '@/components/Datenschutz.vue';
import Impressum from '@/components/Impressum.vue';

const routes = [
	{
		path: '/',
		name: 'Landing',
		component: Landing,
		meta: {
			requiresGuest: true,
			layout: 'visitor',
		},
	},
	{
		path: '/signup',
		name: 'Signup',
		component: Signup,
		meta: {
			requiresGuest: true,
			layout: 'visitor',
		},
	},
	{
		path: '/invitation/:invitationCode',
		name: 'Invitation',
		component: Registration,
		props: true,
		meta: {
			requiresGuest: true,
			layout: 'visitor-white',
		},
	},
	{
		path: '/registration/:invitationCode',
		name: 'Registration',
		component: Registration,
		props: true,
		meta: {
			requiresGuest: true,
			layout: 'visitor-white',
		},
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			requiresGuest: true,
			layout: 'visitor-white',
		},
	},
	{
		path: '/logout',
		name: 'Logout',
		meta: {
			requiresAuth: true,
		},
		beforeEnter: async (to, from, next) => {
			await store.dispatch('auth/logoutUser');
			next({ name: 'Login' });
		},
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/account',
		name: 'Account',
		component: Account,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/invite',
		name: 'Invite',
		component: Invite,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/legal',
		name: 'Legal',
		component: Legal,
		redirect: { name: 'Imprint' },
		children: [
			{
				path: 'imprint',
				name: 'Imprint',
				component: Impressum,
			},
			{
				path: 'data-protection',
				name: 'DataProtection',
				component: Datenschutz,
			},
		],
	},
	{
		path: '/mailrequest',
		name: 'MailRequest',
		component: MailRequest,
		meta: {
			requiresGuest: true,
			layout: 'visitor',
		},
	},
	{
		path: '*',
		redirect: {
			name: 'Dashboard',
		},
	},
];

export default routes;
